import api from './api';
import { ActivityFeedItem } from '../types';

const activityService = {
  getActivity: async (limit = 50): Promise<ActivityFeedItem[]> => {
    const response = await api.get<ActivityFeedItem[]>('/activity', { params: { limit } });
    return response.data;
  },
};

export default activityService;
